import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

export type OnAiAnswerBlueLinkClickParams = {
	url: string;
	isAuxClick?: boolean;
	isContextMenu?: boolean;
};

// When the user clicks a standard HTML link (blue link) inside the AI Answer rendered response.
// Note: InlineCitation and StatusCitation links are overridden via nodeComponents.status and
// bypass the ADF link mark path — they have their own analytics and will NOT trigger this event.
export const onAiAnswerBlueLinkClick = (
	props: commonAttributesType & OnAiAnswerBlueLinkClickParams,
): AnalyticsEventPayload => {

	const { query, answerString, url, isAuxClick = false, isContextMenu = false, source } = props;
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerBlueLink',
		source,
		eventType: 'ui',
		attributes: {
			...filterCommonAttributes(props),
			isAuxClick,
			isContextMenu,
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
			url,
		},
	};
};
